const CODE_SEPARATOR = ": ";

const runErrorCodes = new Set([
  "InvalidSource",
  "ReportUnavailable",
  "NotTabular",
  "DimensionUnavailable",
  "UnsupportedConditions",
  "DuplicateFilterKey",
  "UnknownOverride",
  "OverrideNotAllowed",
  "InvalidParameter",
  "ReportTooLarge",
  "FailedMeasures",
  "MissingColumn",
  "Failed",
]);

const BAD_REQUEST_STATUS = 400;

const findCodeSeparator = (message: string): number | undefined => {
  const separatorIndex = message.indexOf(CODE_SEPARATOR);
  return separatorIndex >= 0 && runErrorCodes.has(message.slice(0, separatorIndex)) ? separatorIndex : undefined;
};

export const removeErrorCode = (message: string): string => {
  const separatorIndex = findCodeSeparator(message);
  return separatorIndex === undefined ? message : message.slice(separatorIndex + CODE_SEPARATOR.length);
};

export const isExpectedRunFailure = (status: number | undefined, message: string): boolean =>
  status === BAD_REQUEST_STATUS && findCodeSeparator(message) !== undefined;
